/**
 * Cloudflare R2 Configuration (SECURE)
 *
 * ⚠️ PUBLIC ONLY CONFIG
 * We only keep public URL and bucket name for generating view links.
 * UPLOADS are now handled via Backend Presigned URLs.
 */

// NOTE: S3Client is REMOVED to prevent Secret Key exposure.
// All uploads use axios to PUT to a presigned URL generated by the Backend.

export const R2_PUBLIC_URL = import.meta.env.VITE_R2_PUBLIC_URL;
